// extracted by mini-css-extract-plugin
export default {"tableCustom":"ReportStyles_tableCustom__RhYaK"};